import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8be97a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-details" }
const _hoisted_2 = { class: "input-container half-width" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  required: "",
  for: "name"
}, "First Name", -1))
const _hoisted_4 = { class: "error-msg" }
const _hoisted_5 = { class: "input-container half-width" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  required: "",
  for: "name"
}, "Last Name", -1))
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "input-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "business-name" }, "Business/Organisation Name (optional)", -1))
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "input-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = { class: "input-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_street" }, "Street Address", -1))
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "input-container third-of-width" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_suburb" }, "Suburb", -1))
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "input-container third-of-width" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_state" }, "State", -1))
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { class: "input-container third-of-width" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postcode" }, "Postcode", -1))
const _hoisted_25 = { class: "error-msg" }
const _hoisted_26 = { class: "input-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone", -1))
const _hoisted_28 = { class: "error-msg" }
const _hoisted_29 = { class: "terms-container" }
const _hoisted_30 = { for: "terms" }
const _hoisted_31 = { class: "input-container" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "artwork[]" }, "Artwork", -1))
const _hoisted_33 = { class: "error-msg" }
const _hoisted_34 = {
  key: 0,
  class: "artwork-wrapper"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "input-container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "payment_option" }, "Payment options", -1))
const _hoisted_38 = { class: "payment-options-buttons" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      id: "user-info-form",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      class: "inputs-wrapper"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          id: "name",
          class: _normalizeClass([_ctx.v$.firstName.$errors.length ? 'error' : '', 'input']),
          modelValue: _ctx.userData.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userData.firstName) = $event)),
          placeholder: "John"
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.firstName.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_4, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_InputText, {
          id: "lastname",
          class: _normalizeClass([_ctx.v$.lastName.$errors.length ? 'error' : '', 'input']),
          modelValue: _ctx.userData.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userData.lastName) = $event)),
          placeholder: "Doe"
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.lastName.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_7, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_InputText, {
          class: _normalizeClass([_ctx.v$.businessName.$errors.length ? 'error' : '', 'input']),
          id: "business-name",
          placeholder: "Your Business",
          modelValue: _ctx.userData.businessName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userData.businessName) = $event))
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.businessName.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_10, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputText, {
          class: _normalizeClass([_ctx.v$.email.$errors.length ? 'error' : '', 'input']),
          placeholder: "example@gmail.com",
          id: "email",
          modelValue: _ctx.userData.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userData.email) = $event))
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_13, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_InputText, {
          placeholder: "Street Address",
          class: _normalizeClass([_ctx.v$.address.details.$errors.length ? 'error' : '', 'input']),
          id: "address_street",
          modelValue: _ctx.userData.address.details,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.address.details) = $event))
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.address.details.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_16, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_InputText, {
          placeholder: "Suburb",
          class: _normalizeClass([_ctx.v$.address.suburb.$errors.length ? 'error' : '', 'input']),
          id: "address_suburb",
          modelValue: _ctx.userData.address.suburb,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userData.address.suburb) = $event))
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.address.suburb.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_19, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_Dropdown, {
          options: _ctx.statesArray,
          placeholder: "VIC, NT...",
          class: _normalizeClass([_ctx.v$.address.state.$errors.length ? 'error' : '', 'input']),
          id: "address_state",
          modelValue: _ctx.userData.address.state,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userData.address.state) = $event))
        }, null, 8, ["options", "class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.address.state.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_22, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_InputMask, {
          class: _normalizeClass([_ctx.v$.postcode.$errors.length ? 'error' : '', 'input']),
          id: "postcode",
          slotChar: "",
          onChange: _ctx.onPostcodeSelect,
          modelValue: _ctx.userData.postcode,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userData.postcode) = $event)),
          mask: "9999",
          placeholder: "9999"
        }, null, 8, ["class", "onChange", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.postcode.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_25, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createVNode(_component_InputText, {
          class: _normalizeClass([_ctx.v$.phone.$errors.length ? 'error' : '', 'input']),
          id: "phone",
          placeholder: "0400 000 000",
          modelValue: _ctx.userData.phone,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userData.phone) = $event))
        }, null, 8, ["class", "modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_28, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.userData.terms,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userData.terms) = $event)),
          class: _normalizeClass([_ctx.v$.terms.$errors.length ? 'error' : '', 'input']),
          binary: true,
          id: "terms"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("label", _hoisted_30, [
          _createTextVNode("I accept the "),
          _createVNode(_component_router_link, { to: "/terms-and-conditions" }, {
            default: _withCtx(() => [
              _createTextVNode("Terms and Conditions")
            ]),
            _: 1
          }),
          _createTextVNode(" and "),
          _createVNode(_component_router_link, { to: "/privacy-policy" }, {
            default: _withCtx(() => [
              _createTextVNode("Privacy Policy")
            ]),
            _: 1
          }),
          _createTextVNode(" I've checked all my details are correct before submitting my order. ")
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createVNode(_component_FileUpload, {
          mode: "basic",
          name: "artwork[]",
          accept: "image/*,application/pdf",
          class: _normalizeClass([_ctx.v$.artwork.$errors.length ? 'error' : '', 'input']),
          fileLimit: 3,
          multiple: true,
          modelValue: _ctx.userData.artwork,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userData.artwork) = $event)),
          maxFileSize: 5000000,
          onSelect: _ctx.onFilesSelection,
          onClear: _ctx.onFilesClear,
          customUpload: "",
          pt: {
            content: { class: 'surface-ground' },
          }
        }, null, 8, ["class", "modelValue", "onSelect", "onClear"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.artwork.$errors, (error) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("small", _hoisted_33, _toDisplayString(error.$message), 1)
          ]))
        }), 128)),
        (_ctx.artworkImages.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artworkImages, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "loaded-image",
                  key: item.id
                }, [
                  _createElementVNode("img", {
                    src: item.url,
                    alt: ""
                  }, null, 8, _hoisted_35)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_SelectButton, {
            id: "payment_option",
            modelValue: _ctx.paymentOption,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.paymentOption) = $event)),
            options: _ctx.paymentOptions,
            optionLabel: "value",
            dataKey: "value",
            "aria-labelledby": "custom"
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("img", {
                src: require(`@/assets/icons/${slotProps.option.icon}.svg`),
                alt: ""
              }, null, 8, _hoisted_39),
              _createTextVNode(" " + _toDisplayString(slotProps.option.description), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_Button, {
          class: "back-button",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.back())),
          label: "BACK"
        }),
        _createVNode(_component_Button, {
          class: "orange-button",
          label: "CONTINUE TO PAYMENT",
          icon: _ctx.spinnerComputed,
          loading: _ctx.checkoutFormProcessing,
          type: "submit"
        }, null, 8, ["icon", "loading"])
      ])
    ], 32)
  ]))
}